export default "__VITE_ASSET__2069ca57__"